module.exports = __webpack_public_path__ + "static/media/bo.24408e4f.svg";